import { useState } from 'react'
import { useGetLoginLinksMutation } from '@services/employees'
import { ReportsProp } from '@templates/ReportsButton'
import {
  BODY_CHECK_REPORT_NAME,
  LINKS_FOR_PASSWORDS_NAME,
  BODY_CHECK_REPORT,
  LINKS_REPORT,
} from '@const/reportNames'
import { useGetBodyCheckReportMutation } from '@services/users'
import useFormProcessor from '@hooks/useFormProcessor'
import { Option } from '@organisms/Select'
import { CompanyDetailed } from '@models/company'
import { DivisionDetailed } from '@models/division'
import { FilialDetailed } from '@models/filial'
import { PositionDetailed } from '@models/position'
import { EmployeesReports } from '@pages/Employees/enums'
import useMe from '@hooks/useMe'
import useEmployeesFiltersModalFields from './useEmployeesFiltersModalFields'

type FormValues = {
  company: Option & CompanyDetailed
  division: Option & DivisionDetailed
  filial: Option & FilialDetailed
  position: Option & PositionDetailed
  nextBodyCheckDate?: string
}

type FormFilters =
  | {
      bodyCheckEndAt: string | undefined
      company: string | undefined
      companyBranch: string | undefined
      subdivision: string | undefined
      jobPosition: string | undefined
    }
  | {
      company: string | undefined
      companyBranch: string | undefined
      subdivision: string | undefined
      jobPosition: string | undefined
    }

const useEmployeesReports = (): ReportsProp => {
  const { divisionCuratorWithOneDivision } = useMe()

  const [selectedReport, setSelectedReport] = useState<
    EmployeesReports | undefined
  >()

  const methods = useFormProcessor()
  const filterModalFields = useEmployeesFiltersModalFields(
    methods,
    selectedReport
  )
  const [
    getBodyCheckReportMutation,
    { isLoading: getBodyCheckReportMutationIsLoading },
  ] = useGetBodyCheckReportMutation()

  const [
    getLoginLinksReportMutation,
    { isLoading: getLoginLinksReportMutationIsLoading },
  ] = useGetLoginLinksMutation()

  const transformFormValues = (form: FormValues): FormFilters => {
    if (selectedReport === EmployeesReports.LINKS_FOR_PASSWORDS_NAME) {
      return {
        company: form.company?.['@id'],
        companyBranch: form.filial?.['@id'],
        subdivision:
          form.division?.['@id'] || divisionCuratorWithOneDivision?.['@id'],
        jobPosition: form.position?.['@id'],
      }
    }

    return {
      bodyCheckEndAt: form.nextBodyCheckDate,
      company: form.company?.['@id'],
      companyBranch: form.filial?.['@id'],
      subdivision:
        form.division?.['@id'] || divisionCuratorWithOneDivision?.['@id'],
      jobPosition: form.position?.['@id'],
    }
  }

  return {
    transformFormValues,
    onSelectReport: setSelectedReport,
    methods,
    items: [
      {
        title: BODY_CHECK_REPORT_NAME,
        isLoading: getBodyCheckReportMutationIsLoading,
        onClick: getBodyCheckReportMutation,
        id: BODY_CHECK_REPORT,
      },
      {
        title: LINKS_FOR_PASSWORDS_NAME,
        isLoading: getLoginLinksReportMutationIsLoading,
        onClick: getLoginLinksReportMutation,
        id: LINKS_REPORT,
      },
    ],
    filterModalFields,
  }
}

export default useEmployeesReports
